import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";

const DownloadButton = ({
  dt,
  id,
  pngOnly = false,
  csvOnly = false,
  pdfOnly = false,
  onClick,
  onPdfClick,
  specialCase = false,
  searchResultHeader = null,
  containerBgColor = "bg-primary-primaryYellow",
  containerBgColorHex = null,
  containerClassName = "",
  buttonBgColor = "#3e3e3e",
  buttonHoverColor = null,
  exportFilename = null,
}) => {
  function exportCSVWithHeader() {
    // If no id is provided but a DataTable ref is available, use PrimeReact's built-in export
    if (!id && dt && dt.current) {
      dt.current.exportCSV();
      return;
    }

    // Get the main container
    const mainElement = document.getElementById(id);
    if (!mainElement) {
      console.error(`Element with id "${id}" not found`);
      return;
    }

    let csvContent = "";

    // Extract header if it exists
    const headerDiv = mainElement.querySelector(
      "div.bg-primary-primaryDarkGray",
    );
    if (headerDiv) {
      let headerText = headerDiv.textContent.trim();
      if (headerText) {
        // Clean the header text - remove commas and extra whitespace
        headerText = headerText
          .replace(/,/g, "") // Remove commas
          .replace(/\s+/g, " ") // Replace multiple spaces with single space
          .trim();
        csvContent += `"${headerText.replace(/"/g, '""')}"\n\n`;
      }
    }

    // Get table data
    const table = mainElement.querySelector("table");
    if (table) {
      const rows = table.querySelectorAll("tr");
      rows.forEach((row) => {
        const cols = row.querySelectorAll("td, th");
        const rowData = Array.from(cols)
          .map((col) => {
            const text = col.textContent.trim();
            return `"${text.replace(/"/g, '""')}"`;
          })
          .join(",");
        csvContent += rowData + "\n";
      });
    }

    // Download CSV
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
    link.download = exportFilename ? `${exportFilename}.csv` : `${id}.csv`;
    link.click();
  }

  function handleDownload() {
    const element = document.getElementById(id);

    html2canvas(element, {
      backgroundColor: "#ffffff",
      scale: 2,
      logging: false,
      useCORS: true,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = exportFilename ? `${exportFilename}.png` : `${id}.png`;
      link.click();
    });
  }

  function handlePdfDownload() {
    if (onPdfClick) {
      onPdfClick();
    }
  }

  const containerStyle = containerBgColorHex
    ? { backgroundColor: containerBgColorHex }
    : {};

  const containerClasses = `flex items-center justify-end gap-2 pr-6 pt-2 w-full h-full ${
    containerBgColorHex ? "" : containerBgColor
  } ${containerClassName}`;

  return (
    <div className={containerClasses} style={containerStyle}>
      {!pngOnly && !pdfOnly && (
        <button
          className={`${
            buttonHoverColor ? "" : "hover:bg-primary-primaryYellow"
          } bg-secondary-buttonGray rounded-full text-white flex items-center pl-1 pr-3 py-[1px]`}
          style={{
            backgroundColor: buttonBgColor,
            ...(buttonHoverColor && {
              transition: "background-color 0.3s",
            }),
          }}
          onMouseEnter={(e) => {
            if (buttonHoverColor) {
              e.currentTarget.style.backgroundColor = buttonHoverColor;
            }
          }}
          onMouseLeave={(e) => {
            if (buttonHoverColor) {
              e.currentTarget.style.backgroundColor = buttonBgColor;
            }
          }}
          onClick={() => {
            if (!specialCase) {
              exportCSVWithHeader();
            } else {
              onClick();
            }
          }}
        >
          <div className="bg-white rounded-full p-1 mr-1">
            <img
              src="/assets/images/download.png"
              className="w-[12px] mr-[2px]"
              alt="download"
            />
          </div>
          <p className="text-center text-[15px] font-bold font-['Poppins'] pt-1">
            .csv
          </p>
        </button>
      )}
      {!csvOnly && !pdfOnly && (
        <button
          className={`${
            buttonHoverColor ? "" : "hover:bg-primary-primaryYellow"
          } rounded-full text-white flex items-center pl-1 pr-3 py-[1px]`}
          style={{
            backgroundColor: buttonBgColor,
            ...(buttonHoverColor && {
              transition: "background-color 0.3s",
            }),
          }}
          onMouseEnter={(e) => {
            if (buttonHoverColor) {
              e.currentTarget.style.backgroundColor = buttonHoverColor;
            }
          }}
          onMouseLeave={(e) => {
            if (buttonHoverColor) {
              e.currentTarget.style.backgroundColor = buttonBgColor;
            }
          }}
          onClick={() => {
            handleDownload();
          }}
        >
          <div className="bg-white rounded-full p-1 mr-1">
            <img
              src="/assets/images/download.png"
              className="w-[12px] mr-[2px]"
              alt="download"
            />
          </div>
          <p className="text-center text-[13.5px] font-bold font-['Poppins'] pt-1 pb-[2px]">
            .png
          </p>
        </button>
      )}
      {!csvOnly && !pngOnly && (
        <button
          className={`${
            buttonHoverColor ? "" : "hover:bg-primary-primaryYellow"
          } rounded-full text-white flex items-center pl-1 pr-3 py-[1px]`}
          style={{
            backgroundColor: buttonBgColor,
            ...(buttonHoverColor && {
              transition: "background-color 0.3s",
            }),
          }}
          onMouseEnter={(e) => {
            if (buttonHoverColor) {
              e.currentTarget.style.backgroundColor = buttonHoverColor;
            }
          }}
          onMouseLeave={(e) => {
            if (buttonHoverColor) {
              e.currentTarget.style.backgroundColor = buttonBgColor;
            }
          }}
          onClick={() => {
            handlePdfDownload();
          }}
        >
          <div className="bg-white rounded-full p-1 mr-1">
            <img
              src="/assets/images/download.png"
              className="w-[12px] mr-[2px]"
              alt="download"
            />
          </div>
          <p className="text-center text-[13.5px] font-bold font-['Poppins'] pt-1 pb-[2px]">
            .pdf
          </p>
        </button>
      )}
    </div>
  );
};

export default DownloadButton;
